import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

import { UserAvatar } from '~/components/UserAvatar/UserAvatar';

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const LinkStyled = styled(Link)({
  '&:focus, &:hover, &:visited, &:link, &:active': {
    textDecoration: 'none',
  },
});

export const UserAvatarStyled = styled(UserAvatar)({
  fontSize: '1rem',
  width: 32,
  height: 32,
  borderRadius: 4,
});
